import {
  ANALYTICS_PRODUCT_NOT_APPLICABLE,
  AnalyticsData,
  AnalyticsService,
  NotAvailable,
  sendCustomDataEventToAnalytics,
  sendCustomEventToAnalytics,
  sendPageViewEventToAnalytics,
} from '@ui-common/analytics'

import { LoanofferAnalyticsModalName, LoanofferCustomEventName, LoanofferPageViewEvent } from './types'

export class LoanOfferAnalyticsService extends AnalyticsService<
  LoanofferPageViewEvent,
  LoanofferCustomEventName,
  LoanofferAnalyticsModalName
> {
  constructor(private readonly data?: AnalyticsData) {
    super()
  }

  getCommonData = (): AnalyticsData => {
    return (
      this.data ?? {
        src: NotAvailable,
        flow: NotAvailable,
        product: ANALYTICS_PRODUCT_NOT_APPLICABLE,
        version: NotAvailable,
        ui_lang: NotAvailable,
      }
    )
  }

  sendPageViewEvent = (view: LoanofferPageViewEvent): void => {
    sendPageViewEventToAnalytics(view, this.getCommonData())
  }

  sendCustomDataEvent = (data: { [p: string]: string }): void => {
    sendCustomDataEventToAnalytics(data)
  }

  sendCustomEvent = (view: LoanofferPageViewEvent, name: LoanofferCustomEventName): void => {
    sendCustomEventToAnalytics(view, name, this.getCommonData())
  }

  sendModalViewEvent = (modal: LoanofferAnalyticsModalName): void => {
    sendPageViewEventToAnalytics(modal, this.getCommonData())
  }
}
